// @ts-nocheck

import { eventCentre, eventCentreClient, eventCentreUtils } from '@img-arena/front-row-seat';

const EventCenterAPI = {
  eventCentre,
  eventCentreClient,
  eventCentreUtils,
};

export default EventCenterAPI;
